import React from "react";
import { Box, SimpleGrid, Flex, Text, Heading } from "@chakra-ui/react";
import {
 Calendar,
 Building2,
 MapPin,
 Award,
 FileCheck,
 BookOpen,
} from "lucide-react";

const QuickFactItem = ({ icon, label, value }) => {
 return (
  <Flex align="center" p={3} bg="gray.50" borderRadius="md" boxShadow="sm">
   <Box mr={3} color="gray.600">
    {icon}
   </Box>
   <Box>
    <Text fontWeight="medium" fontSize="sm" color="gray.500">
     {label}
    </Text>
    <Text fontWeight="semibold">{value || "N/A"}</Text>
   </Box>
  </Flex>
 );
};

const QuickFactsSection = ({
 established,
 type,
 location,
 affiliatedBy,
 approvals,
 collegeCategory,
}) => {
 return (
  <Box mb={8}>
   <Heading as="h2" size="md" mb={4}>
    Quick Facts
   </Heading>

   <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={4}>
    <QuickFactItem
     icon={<Calendar size={20} />}
     label="Established"
     value={established}
    />

    <QuickFactItem icon={<Building2 size={20} />} label="Type" value={type} />

    <QuickFactItem
     icon={<MapPin size={20} />}
     label="Location"
     value={location}
    />

    <QuickFactItem
     icon={<Award size={20} />}
     label="Affiliated By"
     value={affiliatedBy}
    />

    <QuickFactItem
     icon={<FileCheck size={20} />}
     label="Approvals"
     value={approvals}
    />

    <QuickFactItem
     icon={<BookOpen size={20} />}
     label="College Category"
     value={collegeCategory}
    />
   </SimpleGrid>
  </Box>
 );
};

export default QuickFactsSection;
